// extracted by mini-css-extract-plugin
export default {"copyEventForm":"CopyEventModal_copyEventForm__JcHS2","formSection":"CopyEventModal_formSection__SNpjI","formSelectButtons":"CopyEventModal_formSelectButtons__ppHeA"};